import { motion } from "framer-motion";
import { FaChevronDown } from "react-icons/fa";

const FAQItem = ({
  question,
  answer,
}: {
  question: string;
  answer: string;
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.5 }}
      className="rounded-xl border border-gray300 p-6 bg-white mb-5 last-of-type:mb-0"
    >
      <details className="group">
        <summary className="flex justify-between items-center cursor-pointer list-none">
          <h3 className="text-lg font-semibold text-black group-open:text-gray800">
            {question}
          </h3>
          <FaChevronDown className="text-gray500 group-open:text-gray500 group-open:rotate-180 transition-transform duration-700" />
        </summary>
        <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          transition={{ duration: 0.3 }}
          className="mt-2 pt-2 text-gray800 border-t border-gray300"
        >
          {answer}
        </motion.div>
      </details>
    </motion.div>
  );
};

export default FAQItem;
